<template>

  <v-container>
    <v-card
        elevation="2" style="padding:20px">
    <v-row>
      <v-col
          md="12">
        <h2>{{this.$store.state.event.name}}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          md="12">
        <div>{{this.$store.state.event.welcome}}</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          md="12">
        <v-btn class="mr-4" v-on:click="$router.push('/rounds')">
          View Rounds
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          md="12">
        <v-btn class="mr-4" v-on:click="$router.push('/teams')">
          View Standings
        </v-btn>
      </v-col>
    </v-row>
      <v-row>
        <v-col>
          <div class="caption">
            Standings are re-calculated at the end of each round.
          </div>
        </v-col>
      </v-row>
    <v-row>
      <v-col>
        <div class="caption">
          This tool uses swiss paring based on the 'Edmonds Blossom Algorithm', more details can be found
          <a href="https://en.wikipedia.org/wiki/Blossom_algorithm" target="_blank">here</a>.
        </div>
      </v-col>
    </v-row>
  </v-card>
  </v-container>

</template>

<script>

export default {

  data: () => ({
  }),

}
</script>
